import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  sendSupportEmail(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createSupportEmail (
            full_name: "${data.full_name}",
            phone_number: "${data.phone_number}",
            email: "${data.email}",
            message: "${data.message}"
          ) {
            id,
            user {
              id,
              name
            },
            full_name,
            phone_number,
            email,
            message
          }
        }
      `
    })
  },
  sendBuyOrdersEmail(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          sendBuyOrdersEmail (
            full_name: "${data.full_name}",
            phone_number: "${data.phone_number}"
          )
        }
      `
    })
  },
  sendBuyCatalogEmail(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          sendBuyCatalogEmail (
            full_name: "${data.full_name}",
            phone_number: "${data.phone_number}"
          )
        }
      `
    })
  },
  sendBuySmsCampaignEmail(data){
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          sendBuyCatalogEmail (
            full_name: "${data.full_name}",
            phone_number: "${data.phone_number}"
          )
        }
      `
    })
  },
  sendBuyApiCloudEmail(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          sendBuyApiCloudEmail (
            full_name: "${data.full_name}",
            phone_number: "${data.phone_number}"
          )
        }
      `
    })
  },
  sendBuyMariaTriagePassiveFlow(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    return axios.post('', {
      query: `
        mutation {
          sendBuyMariaTriagePassiveFlow (
            full_name: "${data.full_name}",
            phone_number: "${data.phone_number}"
          )
        }
      `
    })
  },
  sendBuyEmailCampaignEmail(data){
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          sendBuyEmailCampaignEmail (
            full_name: "${data.full_name}",
            phone_number: "${data.phone_number}"
          )
        }
      `
    });
  },
  sendBuyModuleSmsEmail(data){
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          sendBuyModuleSmsEmail (
            full_name: "${data.full_name}",
            phone_number: "${data.phone_number}"
          )
        }
      `
    });
  },
}
